








































import { Vue, Prop, Component } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';

@Component({
  components: {
    'label-slot': LabelSlot,
  },
})
export default class SearchCustomComponent extends Vue {
@Prop() label!: string;

@Prop() value!: string;

@Prop() businessUnitId!: string;

@Prop() itemText!: string;

@Prop() option!: string;

@Prop() customOptions: string[] = [];

@Prop({ type: Array, default: () => ([]) })
items!: Array<any>;

@Prop({ type: Boolean, default: false }) multiple! : boolean

updateField(field: string, value) {
  this.$emit(`update:${field}`, value);
}

input(value: string) {
  this.$emit('input', value);
}
}
